"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BL_ORDER_DOCUMENT_TYPE_TO_CATEGORY = exports.BL_ORDER_DOCUMENT_TYPE_LABELS = exports.blOrderDocumentTypeSchema = exports.BL_ORDER_DOCUMENT_TYPES = void 0;
exports.isBLOrderDocumentType = isBLOrderDocumentType;
const zod_1 = require("zod");
exports.BL_ORDER_DOCUMENT_TYPES = [
    'annex_vii',
    'bank_certificate',
    'bill_of_lading',
    'cmr',
    'multimodal_bill_of_lading',
    'weighbridge_ticket',
    'bl_instruction',
    'booking_confirmation',
    'certificate_of_origin',
    'commercial_invoice',
    'confirmed_loading_schedule',
    'final_invoice',
    'freight_certificate',
    'freight_insurance',
    'inspection_certificate',
    'internal_document',
    'loading_ticket',
    'non_radioactive_certificate',
    'packing_list',
    'proforma_invoice',
    'provisional_invoice',
    'down_payment_invoice',
    'supplier_document',
    'weight_certificate',
    'draft_bl',
    'other',
];
exports.blOrderDocumentTypeSchema = zod_1.z.enum(exports.BL_ORDER_DOCUMENT_TYPES);
function isBLOrderDocumentType(value) {
    return exports.BL_ORDER_DOCUMENT_TYPES.includes(value);
}
exports.BL_ORDER_DOCUMENT_TYPE_LABELS = {
    annex_vii: 'Annex VII',
    bank_certificate: 'Bank Certificate',
    bill_of_lading: 'Bill of Lading',
    cmr: 'CMR',
    multimodal_bill_of_lading: 'Multimodal B/L',
    weighbridge_ticket: 'Weighbridge Ticket',
    bl_instruction: 'BL Instruction',
    booking_confirmation: 'Booking Confirmation',
    certificate_of_origin: 'Certificate of Origin',
    commercial_invoice: 'Commercial Invoice',
    confirmed_loading_schedule: 'Confirmed Loading Schedule',
    final_invoice: 'Final Invoice',
    freight_certificate: 'Freight Certificate',
    freight_insurance: 'Freight Insurance',
    inspection_certificate: 'Inspection Certificate',
    internal_document: 'Internal Document',
    loading_ticket: 'Loading Ticket',
    non_radioactive_certificate: 'Non-Radioactive and No War Certificate',
    packing_list: 'Packing List',
    proforma_invoice: 'Proforma Invoice',
    provisional_invoice: 'Provisional Invoice',
    down_payment_invoice: 'Down Payment Invoice',
    supplier_document: 'Supplier Document',
    weight_certificate: 'Weight Certificate',
    draft_bl: 'Draft BL',
    other: 'Other',
};
exports.BL_ORDER_DOCUMENT_TYPE_TO_CATEGORY = {
    annex_vii: 'commercial',
    bank_certificate: 'certificates',
    bill_of_lading: 'shipping',
    cmr: 'shipping',
    multimodal_bill_of_lading: 'shipping',
    weighbridge_ticket: 'shipping',
    bl_instruction: 'shipping',
    booking_confirmation: 'shipping',
    certificate_of_origin: 'certificates',
    commercial_invoice: 'invoices',
    confirmed_loading_schedule: 'shipping',
    final_invoice: 'invoices',
    freight_certificate: 'certificates',
    freight_insurance: 'certificates',
    inspection_certificate: 'certificates',
    internal_document: 'other',
    loading_ticket: 'commercial',
    non_radioactive_certificate: 'certificates',
    packing_list: 'commercial',
    proforma_invoice: 'invoices',
    provisional_invoice: 'invoices',
    down_payment_invoice: 'invoices',
    supplier_document: 'other',
    weight_certificate: 'certificates',
    draft_bl: 'shipping',
    other: 'other',
};
//# sourceMappingURL=bl-order-document-types.js.map